import React from 'react';

import { IComponentLoader } from '../../types/IComponentLoader';

import { Orbit } from '@uiball/loaders';

import './componentLoader.scss';

const ComponentLoader: React.FC<IComponentLoader> = ({ background }) => {
  return (
    <div className={`k-loading-mask component-loader ${background ? 'background-included' : ''}`}>
      <Orbit size={25} speed={1.5} color='black' />
    </div>
  );
};

export default ComponentLoader;
